<button-select
  [model]="selectedValue"
  [a11yLabel]="'privacy' | localize"
  [options]="privacyOptions"
  [uiId]="uiId"
  [selected]="selectedValue"
  [hasOptionCheckIcon]="true"
  [buttonTabindex]="-1"
  (modelChange)="handleChange($event)"></button-select>
